export const Bio = {
  name: "Biyyala Hari Krishna",
  roles: [
    "Full Stack Developer",
    "DevOps Engineer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/harikrishnabiyyala",
  resume: "https://drive.google.com/file/d/1loqatWxm5peYUFtHqyMJXcDnIvjWMab3/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/hari-krishna-biyyala",
  twitter: "https://x.com/HariKrishna_833",
  insta: "https://www.instagram.com/biyyalaharikrishna/",
  facebook: "",
};

export const skills = [
  {
    title: "Backend",
    skills: [
      {
        name: "Spring Framework",
        image: "https://media.licdn.com/dms/image/D4D12AQEICFOK-z0akA/article-cover_image-shrink_720_1280/0/1656604745399?e=2147483647&v=beta&t=-Fjm5QYiJOJNzJ89xGv9VYPNxMNxqIX4jscMWXB6VaM",
      },
      {
        name: "Microservices",
        image:
          "https://t4.ftcdn.net/jpg/03/85/29/69/360_F_385296927_b9V4skbl94TzxL8AiVAMGdpp9hFeZat0.jpg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Apache Kafka",
        image:
          "https://w1.pngwing.com/pngs/489/830/png-transparent-linkedin-logo-big-data-user-profile-microsoft-access-apache-kafka-computer-management-apache-spark-thumbnail.png",
      },

      {
        name: "Hibernate",
        image:
          "https://hibernate.org/images/hibernate_icon_whitebkg.svg",
      },

      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },

      {
        name: "Express Js",
        image: "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
      },

      {
        name: "Apache Camel",
        image:
          "https://i.pinimg.com/originals/00/dc/03/00dc0377822a2698d1575e3cec6a9258.png",
      },
     
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },

  {
    title: "SDE Designs",
    skills: [
      {
        name: "System Design HLD",
        image:
          "https://cdn.iconscout.com/icon/premium/png-256-thumb/system-design-5347949-4460888.png",
      },
      {
        name: "System Design LLD",
        image:
          "https://cdn.iconscout.com/icon/premium/png-256-thumb/system-design-5347949-4460888.png",
      },
      {
        name: "Microservices Designs Patterns",
        image:
          "https://w1.pngwing.com/pngs/535/256/png-transparent-microservices-text-computer-software-line-circle-area-diagram-symmetry-organization-thumbnail.png",
      },
      {
        name: "Coding Design Patterns",
        image:
          "https://w1.pngwing.com/pngs/561/274/png-transparent-cartoon-book-reactive-design-patterns-distributed-computing-computer-programming-system-programming-ebook-edition-application-software-computer-network-blue-thumbnail.png",
      },
    ],
  },

  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtlj4xWgF4i-F23BxC2zBqp4s4rDCbBM5izw&s"
      }
    ],
  },
  {
    title: "Devops",
    skills: [
      {
        name: "Jenkins CI/CD",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Jenkins_logo.svg/1200px-Jenkins_logo.svg.png",
      },
      {
        name: "Github Actions",
        image:
          "https://avatars.githubusercontent.com/u/44036562?s=200&v=4",
      },
      {
        name: "Docker",
        image:
          "https://w7.pngwing.com/pngs/219/411/png-transparent-docker-logo-kubernetes-microservices-cloud-computing-dockers-logo-text-logo-cloud-computing-thumbnail.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Kubernetes_logo_without_workmark.svg/1200px-Kubernetes_logo_without_workmark.svg.png",
      },
      {
        name: "Terraform",
        image:
          "https://cdn-1.webcatalog.io/catalog/terraform-cloud/terraform-cloud-icon-filled-256.webp?v=1714776120568",
      },
      {
        name: "Ansible",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/24/Ansible_logo.svg",
      },
      {
        name: "Prometheus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/115px-Prometheus_software_logo.svg.png?20200109082328",
      },
      {
        name: "Grafana",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-grafana-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-company-vol-3-pack-logos-icons-3030088.png",
      },
      {
        name: "AWS",
        image:
          "https://www.pngall.com/wp-content/uploads/13/AWS-Logo-PNG-File.png",
      },
      {
        name: "Linux",
        image:
          "https://logos-world.net/wp-content/uploads/2020/09/Linux-Logo.png",
      }
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1869px-Python-logo-notext.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEkW5QVyzoVT_A8dA6aG4Y6mf_q64EjDpnpRxm49mvUg&s",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
      },
   
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "ArgoCD",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQdAaL8-NCs0Dwmpfga3yGEnpR586QEtCyvg&s",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://w7.pngwing.com/pngs/509/390/png-transparent-postman-macos-bigsur-icon-thumbnail.png",
      },
     
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1166690750/85f69649-5387-44c2-ba45-81ae13812e36-cover.png",
      },
      {
        name: "Intellij IDEA",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/IntelliJ_IDEA_Icon.svg/512px-IntelliJ_IDEA_Icon.svg.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.yogaiya.in/wp-content/uploads/2020/08/TCS-logo.jpg",
    role: "Fullstack Developer and DevOps Engineer",
    company: "Tata Consultancy Services",
    date: "July 2021 - Present",
    desc: "Working on Enterprise Resource Planning Application , managing DevOps, Performance Optimizations and streamlining the process with automation.",
    skills: [
      "Java",
      "Spring Framework",
      "Hibernate",
      "Apache wicket",
      "Apache Camel",
      "IBM MQ",
      "Oracle",
      "PL/SQL",
      "Tomcat",
      "Elastic APM",
      "ELK stack",
      "Git",
      "Maven",
      "Bitbucket",
      "Jenkins",
      "Nexus",

    ],
    doc: "",
  },
];

export const education = [

  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/4/4b/Mohan_Babu_University_Logo%2C_Tirupati%2C_Andhra_Pradesh%2C_India.png",
    school: "MBU University, Tirupathi",
    date: "May 2017 - Jun 2021",
    grade: "8.92/10",
    desc: "I have done my graducation in Bachelor's degree in Electronic and Communication Engineering at MBU University formerly known as Sree Vidyanikethan Engineering College, Tirupathi. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. ",
    degree: "Bachelor of Technology - BTech, Electronic And Communication Engineering",
  },

  {
    id: 1,
    img: "https://qph.cf2.quoracdn.net/main-qimg-5ec33f1d3b9bb157a992555a67e8c548",
    school: "Narayana Jr college, Kurnool",
    date: "Apr 2015 - Mar 2017",
    grade: "983/1000",
    desc: "I completed my class 12 high school education at Narayana Jr college, Kurnool, where I studied Maths, Physics and Chemistry.",
    degree: "Higher Secondary Certificate (HSC)",
  },

  {
    id: 2,
    img: "https://lh4.googleusercontent.com/proxy/_pEEz87IKHJkCGUWU6Qcc6DEWMyjB5ZSSFJyZhW1RqW0dxZ4jL8LKFJ2NlXf4Tj4uOkE44v555x8MUdx60XDpmT64sS-3wGVCTl6z_Pf3Qx6zRJWRGRCgVFoazzN6UOyjC56JHWUEAc",
    school: "Montessori English Medium Primary School, Kurnool",
    date: "Apr 2014 - Mar 2015",
    grade: "9.8/10",
    desc: "I completed my class 10 education at Montessori English Medium Primary School, Kurnool, where I studied Science with Computer Application.",
    degree: "Secondary School Certificate (SSC)",
  },  
];


export const projects = [
  {
    id: 0,
    title: "Ecommerce Microservice Application",
    date: "Nov 2024",
    description: "Designed and developed a React and Spring Boot based microservices architecture with Keycloak authentication and authorization. Implemented core services (Product, Order, Inventory, Notification) with Kafka-based messaging and Resilience patterns (Circuit Breaker, Retry Mechanism). Used MySQL and MongoDB for structured and unstructured data storage, managed via Flyway. Ensured observability with Grafana, Loki, Tempo, and Prometheus and automated testing using TestContainers. Containerized services with Docker and Kubernetes, integrating CI/CD via GitHub Actions and API management through API Gateway and Swagger.",
    image:
      "https://raw.githubusercontent.com/harikrishnabiyyala/Microservices-Ecommerce-Infra/main/images/HighLevelDesign.png",
    tags: ["Spring Boot", "Microservices", "resilience4j", "Keycloak", "MongoDB", "MySQL", "Docker", "Kubernetes", "Kafka", "Schema Registry", "Avro", "MailTrap", "Grafana", "Prometheus", "Loki", "Tempo"],
    category: "web app",
    github: "https://github.com/harikrishnabiyyala/Microservices-Ecommerce-Infra",
    // webapp: "",
    member: [
      {
        name: "Biyyala Hari Krishna",
        img: "https://github.com/harikrishnabiyyala.png",
        linkedin: "https://www.linkedin.com/in/hari-krishna-biyyala",
        github: "https://github.com/harikrishnabiyyala",
      }
    ],
  },
  {
    id: 1,
    title: "Hotel Booking Application",
    date: "oct 2024 - Nov 2024",
    description:
      "Designed and developed a MERN stack application with TypeScript and Tailwind CSS, featuring JWT authentication, advanced search, sorting, filtering, and secure payments via Stripe. Integrated React Query for efficient state management, React Hook Form for form handling, and Cloudinary for media storage. Implemented automated tests with Playwright and deployed to render.",
    image:
      "https://github.com/harikrishnabiyyala/mern-hotel-booking-app/raw/main/Demo/1.png",
    tags: ["React Js", "MongoDB", "TypeScript", "Express js", "Tailwind CSS", "JWT", "Stripe", "Cloudinary", "Playwrite"],
    category: "web app",
    github: "https://github.com/harikrishnabiyyala/mern-hotel-booking-app",
    webapp: "https://mern-hotel-booking-app-hefx.onrender.com/",
    member: [
      {
        name: "Biyyala Hari Krishna",
        img: "https://github.com/harikrishnabiyyala.png",
        linkedin: "https://www.linkedin.com/in/hari-krishna-biyyala",
        github: "https://github.com/harikrishnabiyyala",
      }
    ],
  },
  {
    id: 2,
    title: "Job Search App",
    date: "Oct 2023 - Nov 2023",
    description:
      "Developed a React Native Mobile application that helps in listig of Jobs based on role and user can click and apply to the jobs",
    image:
      "https://github.com/harikrishnabiyyala/react_native_jobs_App/raw/main/MockImages/1.png",
    tags: ["React Js", "React Native", "Rapid Jsearch API"],
    category: "mobile app",
    github: "https://github.com/harikrishnabiyyala/react_native_jobs_App",
    // webapp: "",
    member: [
      {
        name: "Biyyala Hari Krishna",
        img: "https://github.com/harikrishnabiyyala.png",
        linkedin: "https://www.linkedin.com/in/hari-krishna-biyyala",
        github: "https://github.com/harikrishnabiyyala",
      }
    ],
  },
  {
    id: 3,
    title: "CrowdFunding Decentralized Application",
    date: "Mar 2022",
    description:
      "Developed a React JS CrowdFunding Dapp with Smart Contract developed with solidity and deployed to sepolia Test Net. ",
    image:
      "https://github.com/harikrishnabiyyala/CrowdFunding-dapp/raw/main/Demo/pic-1.png",
    tags: ["Blockchain" , "React Js", "solidity", "Smart Contract", "thirdweb", "sepolia Test Net"],
    category: "web app",
    github: "https://github.com/harikrishnabiyyala/CrowdFunding-dapp",
    webapp: "https://crowdfunding-dapp-thridweb.netlify.app/",
    member: [
      {
        name: "Biyyala Hari Krishna",
        img: "https://github.com/harikrishnabiyyala.png",
        linkedin: "https://www.linkedin.com/in/hari-krishna-biyyala",
        github: "https://github.com/harikrishnabiyyala",
      }
    ],
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my B Tech journey" },
  { year: 2021, text: "Started my Tech career" },
];
